import { css } from '@emotion/react';
import { formatDate } from '@frontend/date';
import { Trans, useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Chip, Heading, Text, TextLink } from '@frontend/design-system';
import JustiFiLogoImg from '../../assets/justifi.svg?react';
import { merchantStatusStyles } from '../styles';
import { JustifiStatusText } from './justifi-status-text';

type JustifiCardProps = {
  isAchPaymentsActive?: boolean;
  isTerminalPaymentsActive?: boolean;
  isCardNotPresentPaymentsActive?: boolean;
  createdAt?: string;
  id?: string;
  businessName?: string;
  isActive: boolean;
};

export const JustifiCard = ({
  isAchPaymentsActive,
  isTerminalPaymentsActive,
  isCardNotPresentPaymentsActive,
  createdAt,
  id,
  businessName,
  isActive,
}: JustifiCardProps) => {
  const { t } = useTranslation('payments', { keyPrefix: 'settings' });

  return (
    <div>
      <div css={[merchantStatusStyles.title, { justifyContent: 'flex-start' }]}>
        <JustiFiLogoImg />
        <Chip variant={isActive ? 'success' : 'neutral'}>{isActive ? t('Active') : t('Inactive')}</Chip>
      </div>
      <div css={{ marginBottom: theme.spacing(2) }}>
        <Trans t={t}>
          <Text>
            To manage your merchant account, please submit a{' '}
            <TextLink onClick={() => window.open('https://justifi.formstack.com/forms/customer_changes', '_blank')}>
              JustiFi Support ticket.
            </TextLink>
          </Text>
        </Trans>
      </div>
      <Text color='light' css={{ margin: 0 }}>
        {t('Merchant Account')}
      </Text>
      <Heading
        as='p'
        level={3}
        css={css`
          margin: ${theme.spacing(0, 0, 2)};
        `}
      >
        {businessName || 'N/A'}
      </Heading>
      <div
        css={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: theme.spacing(2),
        }}
      >
        <JustifiStatusText
          label={t('ACH Payments Status')}
          isStatusActive={!!isAchPaymentsActive}
          trackingId='justifi-ach-status'
        />
        <JustifiStatusText
          label={t('Terminal Payments Status')}
          isStatusActive={!!isTerminalPaymentsActive}
          trackingId='justifi-terminal-status'
        />
        <JustifiStatusText
          label={t('Card Not Present Status')}
          isStatusActive={!!isCardNotPresentPaymentsActive}
          trackingId='justifi-card-status'
        />
        <JustifiStatusText
          label={t('Submitted Date')}
          value={formatDate(createdAt, 'MMMM d, YYYY')}
          trackingId='justifi-submitted-date'
        />
        <JustifiStatusText label={t('Account ID')} value={id || 'N/A'} trackingId='justifi-account-id' />
      </div>
    </div>
  );
};
